import { Wrench, ShieldCheck, ListChecks, BookOpen } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

const points = [
  {
    icon: Wrench,
    title: "Praxis statt Theorie",
    text: "Konkrete Situationen und verständliche Einordnung statt abstrakter Betrachtung.",
  },
  {
    icon: ShieldCheck,
    title: "Rechtssicherer handeln",
    text: "Verstehen, welche Fragen relevant sind und wo genauer hingeschaut werden muss.",
  },
  {
    icon: ListChecks,
    title: "Schritt für Schritt",
    text: "Klare Strukturen schaffen einen nachvollziehbaren Zugang zum Datenschutz.",
  },
  {
    icon: BookOpen,
    title: "Ohne juristisches Vorwissen",
    text: "Die Inhalte sind auch für Leserinnen und Leser ohne Datenschutzstudium oder juristische Ausbildung verständlich aufgebaut.",
  },
];

const Advantage = () => (
  <section
    data-testid="advantage-section"
    className="relative py-24 sm:py-32 bg-navy-900 border-y border-white/5 overflow-hidden"
  >
    <div
      aria-hidden="true"
      className="absolute -top-40 right-0 h-[480px] w-[480px] rounded-full bg-[radial-gradient(circle,rgba(0,102,255,0.14)_0%,rgba(13,20,36,0)_70%)]"
    />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <Overline>Der Praxisvorteil</Overline>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white mt-4">
          Vom Einsatzalltag aus gedacht.
        </h2>
        <p className="mt-6 text-base md:text-lg text-gray-400 leading-relaxed">
          Der entscheidende Vorteil: Das Buch denkt vom Alltag der
          Blaulichtorganisationen aus.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-px overflow-hidden rounded-xl border border-white/8 bg-white/5 sm:grid-cols-2">
        {points.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.1} className="h-full">
            <div
              data-testid={`advantage-point-${i + 1}`}
              className="flex h-full flex-col gap-4 bg-navy-900 p-8 transition-colors duration-300 hover:bg-navy-800"
            >
              <div className="flex items-center gap-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-blau/30 bg-blau/10 text-blau-glow">
                  <p.icon size={18} strokeWidth={1.8} aria-hidden="true" />
                </span>
                <span className="font-mono text-xs text-gray-500">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-display text-lg font-bold text-white">
                {p.title}
              </h3>
              <p className="text-sm text-gray-400 leading-relaxed">{p.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Advantage;
